/**
 * 线下培训班级学员列表功能
 * @Author:wuTao
 * @Date 2020/3/6
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateConfig, templateConfig} from './config';

import {component_tool, framework_tool, utils_tool} from '@/tool'

let {checkStrLength,Session} = utils_tool;
let { WizSpin, WizBrowserExport} = component_tool;
let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;
import { WizCard } from 'wiz-components/lib';
import ExamInfo  from './examInfo';

class ErrorQuestionInfoList extends WizContainer {

  componentName = 'ErrorQuestionInfoList';

  constructor(props) {
    super(props);
    const {history} = props;
    this.state = {
      
    };
    this.initialValue = {};
  }

  _componentWillMount() {
    const {history} = this.props;
    if (history.location.record) {
      Session.set('examInfo', history.location.record);
      this.initialValue = history.location.record;
    } else if (Session.get('examInfo')) {
      this.initialValue = Session.get('examInfo') ? Session.get('examInfo') : {};
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '题目内容',
        field: 'title',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '题目编号',
        field: 'number',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '所属分类',
        field: 'categoryNames',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '题目类型',
        field: 'typeStr',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '难度',
        field: 'difficultyStr',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '答题人数',
        field: 'answerPersonIdCount',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '答题次数',
        field: 'answerTimeCount',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '答错次数',
        field: 'answerErrorTimeCount',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '错题率',
        field: 'answerErrorRate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if(o['success']){
      let data = o['data']
      WizBrowserExport({
        title: '错题率分析',
        sheetName: '错题率分析',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '错题率分析.xlsx'
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    const {examRecordLoading} = this.props;
    let initialValue = this.initialValue;
    const {id,title,startDate,endDate} = initialValue;
    let _templateConfig = templateConfig({
      examId: id, 
      examName: title,
      examDate : startDate+'~'+endDate
    });
    let _reduxTemplateConfig = reduxTemplateConfig({
      examId: id,
      templateConfig: _templateConfig,
      apiDataFormat: {
        export: this._handleFile,
      },
    });
    
    let record = {examName:title,examDate:startDate+'~'+endDate}
    return <>
        <ExamInfo record={ record } />
        <WizCard title={'错题率分析'}>
          <WizReduxTemplate {..._reduxTemplateConfig} />
        </WizCard>

      </>
  }
}

const mapStateToProps = (state, ownProps) => {
  const {examRecord } = state;
  const load = modelUtils.getLoadingState(state, ['examRecord']);
  return {
    ...load
  }
};

export default connect(mapStateToProps)(ErrorQuestionInfoList);
